import { twMerge } from '@/utilities';

type SkeletorWillComeBackProps = { className?: string };

const SkeletorWillComeBack: React.FC<SkeletorWillComeBackProps> = ({
  className,
}) => {
  return (
    <div className="py-8 px-4 bg-light animate-pulse w-full">
      <div
        className={twMerge('bg-gray-500 opacity-50 rounded-lg h-10', className)}
      />
    </div>
  );
};

export default SkeletorWillComeBack;
